export const IN_REP1 = 1
export const IN_REP2 = 2
export const IN_REP3 = 4
export const OUT_REP1 = 8
export const OUT_REP2 = 16
export const OUT_REP3 = 32

export const pourcentageBaro = [
  {
    sex: 'H',
    ageRange: { min: 18, max: 24 },
    [IN_REP1 + IN_REP2 + IN_REP3]: 61.4,
    [IN_REP1]: 62.02,
    [IN_REP2]: 96.32,
    [IN_REP3]: 82.56,
    [OUT_REP1 | OUT_REP2 | OUT_REP3]: 38.6,
    [OUT_REP1]: 37.98,
    [OUT_REP2]: 3.68,
    [OUT_REP3]: 17.44,
  },
  {
    sex: 'H',
    ageRange: { min: 25, max: 34 },
    [IN_REP1 + IN_REP2 + IN_REP3]: 66.53,
    [IN_REP1]: 66.68,
    [IN_REP2]: 95.8,
    [IN_REP3]: 86.22,
    [OUT_REP1 | OUT_REP2 | OUT_REP3]: 33.47,
    [OUT_REP1]: 33.32,
    [OUT_REP2]: 4.2,
    [OUT_REP3]: 13.78,
  },
  {
    sex: 'H',
    ageRange: { min: 35, max: 44 },
    [IN_REP1 + IN_REP2 + IN_REP3]: 71.56,
    [IN_REP1]: 76.09,
    [IN_REP2]: 90.71,
    [IN_REP3]: 87.72,
    [OUT_REP1 | OUT_REP2 | OUT_REP3]: 28.44,
    [OUT_REP1]: 23.91,
    [OUT_REP2]: 9.29,
    [OUT_REP3]: 12.28,
  },
  {
    sex: 'H',
    ageRange: { min: 45, max: 54 },
    [IN_REP1 + IN_REP2 + IN_REP3]: 69.1,
    [IN_REP1]: 72.71,
    [IN_REP2]: 90.41,
    [IN_REP3]: 85.12,
    [OUT_REP1 | OUT_REP2 | OUT_REP3]: 30.9,
    [OUT_REP1]: 27.29,
    [OUT_REP2]: 9.59,
    [OUT_REP3]: 14.88,
  },
  {
    sex: 'H',
    ageRange: { min: 55, max: 64 },
    [IN_REP1 + IN_REP2 + IN_REP3]: 64.8,
    [IN_REP1]: 75.35,
    [IN_REP2]: 80.56,
    [IN_REP3]: 81.78,
    [OUT_REP1 | OUT_REP2 | OUT_REP3]: 35.2,
    [OUT_REP1]: 24.65,
    [OUT_REP2]: 19.44,
    [OUT_REP3]: 18.22,
  },
  {
    sex: 'H',
    ageRange: { min: 65, max: 75 },
    [IN_REP1 + IN_REP2 + IN_REP3]: 63.46,
    [IN_REP1]: 77.92,
    [IN_REP2]: 75.89,
    [IN_REP3]: 76.97,
    [OUT_REP1 | OUT_REP2 | OUT_REP3]: 36.54,
    [OUT_REP1]: 22.08,
    [OUT_REP2]: 24.11,
    [OUT_REP3]: 23.03,
  },
  {
    sex: 'F',
    ageRange: { min: 18, max: 24 },
    [IN_REP1 + IN_REP2 + IN_REP3]: 81.67,
    [IN_REP1]: 82.36,
    [IN_REP2]: 99.31,
    [IN_REP3]: 97.71,
    [OUT_REP1 | OUT_REP2 | OUT_REP3]: 18.33,
    [OUT_REP1]: 17.64,
    [OUT_REP2]: 0.69,
    [OUT_REP3]: 2.29,
  },
  {
    sex: 'F',
    ageRange: { min: 25, max: 34 },
    [IN_REP1 + IN_REP2 + IN_REP3]: 82.55,
    [IN_REP1]: 83.94,
    [IN_REP2]: 97.84,
    [IN_REP3]: 95.02,
    [OUT_REP1 | OUT_REP2 | OUT_REP3]: 17.45,
    [OUT_REP1]: 16.06,
    [OUT_REP2]: 2.16,
    [OUT_REP3]: 4.98,
  },
  {
    sex: 'F',
    ageRange: { min: 35, max: 44 },
    [IN_REP1 + IN_REP2 + IN_REP3]: 85.2,
    [IN_REP1]: 86.38,
    [IN_REP2]: 98.27,
    [IN_REP3]: 96.35,
    [OUT_REP1 | OUT_REP2 | OUT_REP3]: 14.8,
    [OUT_REP1]: 13.62,
    [OUT_REP2]: 1.73,
    [OUT_REP3]: 3.65,
  },
  {
    sex: 'F',
    ageRange: { min: 45, max: 54 },
    [IN_REP1 + IN_REP2 + IN_REP3]: 90.41,
    [IN_REP1]: 92.08,
    [IN_REP2]: 97.51,
    [IN_REP3]: 97.55,
    [OUT_REP1 | OUT_REP2 | OUT_REP3]: 9.59,
    [OUT_REP1]: 7.92,
    [OUT_REP2]: 2.49,
    [OUT_REP3]: 2.45,
  },
  {
    sex: 'F',
    ageRange: { min: 45, max: 64 },
    [IN_REP1 + IN_REP2 + IN_REP3]: 86.51,
    [IN_REP1]: 91.15,
    [IN_REP2]: 93.24,
    [IN_REP3]: 96.61,
    [OUT_REP1 | OUT_REP2 | OUT_REP3]: 13.49,
    [OUT_REP1]: 8.85,
    [OUT_REP2]: 6.76,
    [OUT_REP3]: 3.39,
  },
  {
    sex: 'F',
    ageRange: { min: 65, max: 75 },
    [IN_REP1 + IN_REP2 + IN_REP3]: 85.77,
    [IN_REP1]: 94.59,
    [IN_REP2]: 89.24,
    [IN_REP3]: 96.64,
    [OUT_REP1 | OUT_REP2 | OUT_REP3]: 14.23,
    [OUT_REP1]: 5.41,
    [OUT_REP2]: 10.76,
    [OUT_REP3]: 3.36,
  },
]

export const calPerGlass = {
  0: 0,
  1: 10,
  2: 20,
  3: 30,
  4: 40,
  5: 50,
  6: 60,
  7: 70,
  8: 80,
  9: 90,
  10: 100,
  11: 110,
  12: 120,
  13: 130,
  14: 140,
  15: 150,
  16: 160,
  17: 170,
  18: 180,
  19: 190,
  20: 200,
  21: 210,
  22: 220,
  23: 230,
  24: 240,
  25: 250,
  26: 260,
  27: 270,
  28: 280,
  29: 290,
  30: 300,
  31: 310,
  32: 320,
  33: 330,
  34: 340,
  35: 350,
  36: 360,
  37: 370,
  38: 380,
  39: 390,
  40: 400,
  41: 410,
  42: 420,
  43: 430,
  44: 440,
  45: 450,
  46: 460,
  47: 470,
  48: 480,
  49: 490,
  50: 500,
  51: 510,
  52: 520,
  53: 530,
  54: 540,
  55: 550,
  56: 560,
  57: 570,
  58: 580,
  59: 590,
  60: 600,
  61: 610,
  62: 620,
  63: 630,
  64: 640,
  65: 650,
  66: 660,
  67: 670,
  68: 680,
  69: 690,
  70: 700,
  71: 710,
  72: 720,
  73: 730,
  74: 740,
  75: 750,
  76: 760,
  77: 770,
  78: 780,
  79: 790,
  80: 800,
  81: 810,
  82: 820,
  83: 830,
  84: 840,
  85: 850,
  86: 860,
  87: 870,
  88: 880,
  89: 890,
  90: 900,
  91: 910,
  92: 920,
  93: 930,
  94: 940,
  95: 950,
  96: 960,
  97: 970,
  98: 980,
  99: 990,
  100: 1000,
}

export const kBouchePhxLarx = {
  0: 0,
  1: 2,
  2: 5,
  3: 7,
  4: 10,
  5: 13,
  6: 15,
  7: 18,
  8: 21,
  9: 24,
  10: 27,
  11: 30,
  12: 33,
  13: 36,
  14: 39,
  15: 43,
  16: 46,
  17: 49,
  18: 53,
  19: 57,
  20: 60,
  21: 64,
  22: 68,
  23: 72,
  24: 76,
  25: 81,
  26: 85,
  27: 89,
  28: 94,
  29: 99,
  30: 103,
  31: 108,
  32: 113,
  33: 118,
  34: 123,
  35: 129,
  36: 134,
  37: 140,
  38: 146,
  39: 151,
  40: 157,
  41: 164,
  42: 170,
  43: 176,
  44: 183,
  45: 190,
  46: 197,
  47: 204,
  48: 211,
  49: 219,
  50: 226,
  51: 234,
  52: 242,
  53: 250,
  54: 259,
  55: 267,
  56: 276,
  57: 285,
  58: 294,
  59: 304,
  60: 313,
  61: 323,
  62: 333,
  63: 344,
  64: 354,
  65: 365,
  66: 376,
  67: 388,
  68: 399,
  69: 411,
  70: 423,
  71: 436,
  72: 449,
  73: 462,
  74: 475,
  75: 489,
  76: 503,
  77: 518,
  78: 532,
  79: 548,
  80: 563,
  81: 579,
  82: 595,
  83: 612,
  84: 629,
  85: 646,
  86: 664,
  87: 682,
  88: 701,
  89: 720,
  90: 740,
  91: 760,
  92: 781,
  93: 802,
  94: 823,
  95: 845,
  96: 868,
  97: 891,
  98: 915,
  99: 939,
  100: 964,
}

export const kOesophage = {
  0: 0,
  1: 3,
  2: 7,
  3: 10,
  4: 14,
  5: 17,
  6: 21,
  7: 25,
  8: 29,
  9: 33,
  10: 38,
  11: 42,
  12: 47,
  13: 51,
  14: 56,
  15: 61,
  16: 67,
  17: 72,
  18: 77,
  19: 83,
  20: 89,
  21: 95,
  22: 102,
  23: 108,
  24: 115,
  25: 122,
  26: 129,
  27: 136,
  28: 144,
  29: 152,
  30: 160,
  31: 169,
  32: 177,
  33: 186,
  34: 196,
  35: 205,
  36: 215,
  37: 225,
  38: 236,
  39: 247,
  40: 258,
  41: 270,
  42: 281,
  43: 294,
  44: 307,
  45: 320,
  46: 333,
  47: 347,
  48: 362,
  49: 377,
  50: 392,
  51: 408,
  52: 425,
  53: 442,
  54: 459,
  55: 477,
  56: 496,
  57: 515,
  58: 535,
  59: 556,
  60: 577,
  61: 599,
  62: 622,
  63: 645,
  64: 669,
  65: 694,
  66: 720,
  67: 746,
  68: 774,
  69: 802,
  70: 831,
  71: 861,
  72: 893,
  73: 925,
  74: 958,
  75: 992,
  76: 1028,
  77: 1064,
  78: 1102,
  79: 1141,
  80: 1181,
  81: 1222,
  82: 1265,
  83: 1310,
  84: 1355,
  85: 1402,
  86: 1451,
  87: 1501,
  88: 1553,
  89: 1607,
  90: 1662,
  91: 1719,
  92: 1778,
  93: 1839,
  94: 1902,
  95: 1966,
  96: 2033,
  97: 2102,
  98: 2174,
  99: 2247,
  100: 2323,
}

export const kColonRectum = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
  11: 11,
  12: 12,
  13: 13,
  14: 14,
  15: 16,
  16: 17,
  17: 18,
  18: 19,
  19: 20,
  20: 21,
  21: 23,
  22: 24,
  23: 25,
  24: 26,
  25: 27,
  26: 29,
  27: 30,
  28: 31,
  29: 32,
  30: 34,
  31: 35,
  32: 36,
  33: 38,
  34: 39,
  35: 40,
  36: 42,
  37: 43,
  38: 44,
  39: 46,
  40: 47,
  41: 49,
  42: 50,
  43: 52,
  44: 53,
  45: 54,
  46: 56,
  47: 58,
  48: 59,
  49: 61,
  50: 62,
  51: 64,
  52: 65,
  53: 67,
  54: 69,
  55: 70,
  56: 72,
  57: 73,
  58: 75,
  59: 77,
  60: 79,
  61: 80,
  62: 82,
  63: 84,
  64: 86,
  65: 87,
  66: 89,
  67: 91,
  68: 93,
  69: 95,
  70: 97,
  71: 99,
  72: 101,
  73: 103,
  74: 104,
  75: 106,
  76: 108,
  77: 110,
  78: 113,
  79: 115,
  80: 117,
  81: 119,
  82: 121,
  83: 123,
  84: 125,
  85: 127,
  86: 130,
  87: 132,
  88: 134,
  89: 136,
  90: 139,
  91: 141,
  92: 143,
  93: 146,
  94: 148,
  95: 150,
  96: 153,
  97: 155,
  98: 158,
  99: 160,
  100: 163,
}

export const kFoie = {
  0: 0,
  1: 1,
  2: 1,
  3: 2,
  4: 2,
  5: 3,
  6: 3,
  7: 4,
  8: 5,
  9: 5,
  10: 6,
  11: 6,
  12: 7,
  13: 8,
  14: 8,
  15: 9,
  16: 9,
  17: 10,
  18: 11,
  19: 11,
  20: 12,
  21: 12,
  22: 13,
  23: 14,
  24: 14,
  25: 15,
  26: 16,
  27: 16,
  28: 17,
  29: 18,
  30: 18,
  31: 19,
  32: 20,
  33: 20,
  34: 21,
  35: 22,
  36: 22,
  37: 23,
  38: 24,
  39: 24,
  40: 25,
  41: 26,
  42: 27,
  43: 27,
  44: 28,
  45: 29,
  46: 29,
  47: 30,
  48: 31,
  49: 32,
  50: 32,
  51: 33,
  52: 34,
  53: 35,
  54: 35,
  55: 36,
  56: 37,
  57: 38,
  58: 38,
  59: 39,
  60: 40,
  61: 41,
  62: 42,
  63: 42,
  64: 43,
  65: 44,
  66: 45,
  67: 46,
  68: 46,
  69: 47,
  70: 48,
  71: 49,
  72: 50,
  73: 51,
  74: 51,
  75: 52,
  76: 53,
  77: 54,
  78: 55,
  79: 56,
  80: 57,
  81: 57,
  82: 58,
  83: 59,
  84: 60,
  85: 61,
  86: 62,
  87: 63,
  88: 64,
  89: 65,
  90: 66,
  91: 67,
  92: 67,
  93: 68,
  94: 69,
  95: 70,
  96: 71,
  97: 72,
  98: 73,
  99: 74,
  100: 75,
}

export const kSein = {
  0: 0,
  1: 1,
  2: 2,
  3: 4,
  4: 5,
  5: 6,
  6: 8,
  7: 9,
  8: 10,
  9: 12,
  10: 13,
  11: 15,
  12: 16,
  13: 17,
  14: 19,
  15: 20,
  16: 22,
  17: 23,
  18: 25,
  19: 26,
  20: 28,
  21: 30,
  22: 31,
  23: 33,
  24: 34,
  25: 36,
  26: 38,
  27: 39,
  28: 41,
  29: 43,
  30: 45,
  31: 46,
  32: 48,
  33: 50,
  34: 52,
  35: 54,
  36: 56,
  37: 58,
  38: 60,
  39: 62,
  40: 64,
  41: 66,
  42: 68,
  43: 70,
  44: 72,
  45: 74,
  46: 76,
  47: 78,
  48: 81,
  49: 83,
  50: 85,
  51: 87,
  52: 90,
  53: 92,
  54: 94,
  55: 97,
  56: 99,
  57: 102,
  58: 104,
  59: 107,
  60: 109,
  61: 112,
  62: 115,
  63: 117,
  64: 120,
  65: 123,
  66: 125,
  67: 128,
  68: 131,
  69: 134,
  70: 137,
  71: 140,
  72: 143,
  73: 146,
  74: 149,
  75: 152,
  76: 155,
  77: 158,
  78: 161,
  79: 164,
  80: 168,
  81: 171,
  82: 174,
  83: 178,
  84: 181,
  85: 185,
  86: 188,
  87: 192,
  88: 195,
  89: 199,
  90: 203,
  91: 207,
  92: 210,
  93: 214,
  94: 218,
  95: 222,
  96: 226,
  97: 230,
  98: 234,
  99: 238,
  100: 243,
}



// WEBPACK FOOTER //
// ./src/constants/results.ts